import { useQuery } from "@tanstack/react-query";
import SharedRecordAPI from "../../api/SharedRecordAPI";
import { CloudApp } from "../../../types/GlobalInterfaces";

const empty: [] = [];

export default function useTenantsWithApp(sharedRecordID: string) {
  const tenantsWithApp = useQuery({
    queryKey: ["tenantsWithApp", sharedRecordID],
    queryFn: () =>
      SharedRecordAPI.getTenantsWithApp(sharedRecordID).then(
        (data) => data?.data?.data
      ),
    enabled: !!sharedRecordID,
  });

  return {
    tenants: tenantsWithApp.data?.tenants || empty,
    loadingTenants: tenantsWithApp.isLoading,
    app: tenantsWithApp.data?.app as CloudApp,
  };
}
